export default "__VITE_ASSET__qtX8iUml__"